import Work from './Work';
import Bio from './Bio';
import Blog from './Blog';
import BlogPost from './BlogPost';
import Tropicana from './Work/Tropicana';
import Walmart from './Work/Walmart';
import Publix from './Work/Publix';
import NotFound from './NotFound';
import PasswordGate from './Password';

export const pages = [
  {
    path: '/',
    element: <Work />,
  },
  {
    path: '/bio',
    element: <Bio />,
  },
  {
    path: '/password-gate',
    element: <PasswordGate />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPost />,
  },
  {
    path: '/work/tropicana',
    element: <Tropicana />,
  },
  {
    path: '/work/walmart',
    element: <Walmart />,
  },
  {
    path: '/work/publix',
    element: <Publix />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];
